(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningsListController', WarningsListController);

    WarningsListController.$inject = ['$q', 'entity', '$state', '$window', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'WarningsDashboard', '$scope', '$timeout', '$uibModal', 'TabObjects', 'AlertRules', 'TabFleets', 'WarningCategory'];

    function WarningsListController($q, entity, $state, $window, ParseLinks, AlertService, pagingParams, paginationConstants, WarningsDashboard, $scope, $timeout, $uibModal, TabObjects, AlertRules, TabFleets, WarningCategory) {
        var vm = this;
        if (entity != null) {
            vm.myDomainNotification = entity;
        } else {
            vm.myDomainNotification = null;
        }
        vm.applySort = applySort;
        vm.transition = transition;
        vm.applySearch = applySearch;
        vm.exportTable = exportTable;
        vm.changePageSize = changePageSize;
        vm.loadAllToExport = loadAllToExport;
        vm.parseWarningLevel = parseWarningLevel;
        vm.applyWarningFilter = applyWarningFilter;

        vm.currentState = "warnings-dashboard";
        vm.currentStateFilter = "warnings-dashboard-filter";
        vm.picker = {
            start: false,
            end: false
        };

        vm.fleetOptions = [];
        vm.categoryOptions = [];
        vm.warningNameOptions = [];
        vm.tabObjectsToExport = [];
        vm.fleetSelectedAtStart = [];
        vm.warningSelectedAtStart = [];
        vm.categorySelectedAtStart = [];

        vm.seeMore = 5;
        vm.sorting = [];
        vm.warnings = [];
        vm.sortIcon = {};
        var sortingMap = {};
        vm.filterDetail = [];
        vm.warningsGroup = [];
        vm.showClose = false;
        vm.searchParams = pagingParams.search;
        vm.predicates = pagingParams.predicates;

        var retrievedOrder = localStorage.getItem(vm.currentState);
        if (retrievedOrder != null && retrievedOrder != "null")
            vm.predicates = JSON.parse(retrievedOrder);

        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        if (localStorage.getItem("is-from-see-more") == null) {
            localStorage.setItem("is-from-see-more", JSON.stringify({isFromSeeMore: false}));
        }

        vm.tabFleets = TabFleets.query({
            page: 0,
            size: 100
        });
        vm.categories = WarningCategory.query({
            page: 0,
            size: 100
        });
        vm.systemWarnings = AlertRules.querySystem({
            page: 0,
            size: 1000
        });
        vm.warningNames = AlertRules.query({
            page: 0,
            size: 1000
        });

        // Promises from $resource queries for fleets, categories, system warnings and warnings
        var fleetsPromise = vm.tabFleets.$promise;
        var categoriesPromise = vm.categories.$promise;
        var systemWarningsPromise = vm.systemWarnings.$promise;
        var warningsPromise = vm.warningNames.$promise;

        vm.tabFleets.$promise.then(function (fleets) {
            fleets.forEach(function (fleet) {
                vm.fleetOptions.push({id: fleet.id, label: fleet.fleetName});
            });
            vm.categories.$promise.then(function (categories) {
                categories.unshift({id: -1, warningName: 'Monitoring Warning'});
                vm.systemWarnings.$promise.then(function (systemWarnings) {
                    systemWarnings.warnings.forEach((systemWarning) => {
                        systemWarning.warningCategory = {id: -1, warningName: "Monitoring Warning"};
                    });
                    vm.systemWarnings = vm.systemWarnings.warnings;
                    vm.warningNames.$promise.then(function (warnings) {
                        vm.systemWarnings.forEach((systemWarning) => {
                            warnings.warnings.unshift(systemWarning);
                        });
                        vm.warningNames = vm.warningNames.warnings;
                        categories.forEach(category => {
                            if(warnings.warnings.some(w => w.warningCategory.warningName === category.warningName)) {
                                vm.categoryOptions.push({id: category.id, label: category.warningName})
                            }
                        });
                        warnings.warnings.forEach(warning => {
                            if (!vm.warningNameOptions.some(w => w.id === warning.id || w.label === warning.name))
                                vm.warningNameOptions.push({id: warning.id, label: warning.name});
                        });
                    });
                });
            });
        });

        function sort() {
            var sortFields = [];
            var keys = Object.keys(vm.predicates);
            for (var key in keys) {
                var predicate = keys[key];
                sortFields.push(predicate + ',' + (vm.predicates[predicate] ? 'asc' : 'desc'));
            }
            localStorage.setItem(vm.currentState, JSON.stringify(vm.predicates));
            return sortFields;
        }

        var v = JSON.parse(localStorage.getItem('is-from-see-more'));
        if (v.isFromSeeMore) {
            vm.isFromSeeMore = v.isFromSeeMore;
            var backToLastPage = JSON.parse(localStorage.getItem("warnings-page-back-detail"));
            vm.page = backToLastPage.pageBack;
            vm.itemsPerPageChosen = backToLastPage.sizeBack;
        }

        vm.filter = vm.isFromSeeMore ? JSON.parse(localStorage.getItem('save-filter')) : pagingParams.filter;
        localStorage.setItem("save-filter", JSON.stringify(vm.filter));

        vm.loadAll  = function (notify) {
            var page = {
                page: vm.isFromSeeMore ? vm.page - 1 : pagingParams.page - 1,
                size: vm.itemsPerPageChosen,
                sort: sort(),
                search: vm.searchParams
            };
            if (vm.filter.hasOwnProperty('sizeP'))
                delete vm.filter.sizeP;
            if (vm.filter.hasOwnProperty('warningGetAll'))
                delete vm.filter.warningGetAll;
            if (vm.filter.hasOwnProperty('warningObjectCode'))
                delete vm.filter.warningObjectCode;
            if (vm.filter.hasOwnProperty('warningFleet'))
                delete vm.filter.warningFleet;
            if (vm.filter.hasOwnProperty('warningName'))
                delete vm.filter.warningName;

            WarningsDashboard.search(page, vm.filter, innerOnSuccess, onError);

            function innerOnSuccess(data, headers) {
                vm.showClose = vm.filter.status !== 'open';
                onSuccess(data, headers, notify);
            }
        }

        function onSuccess(data, headers, notify) {
            vm.warnings = data[0];
            vm.totalItems = data[0].count;
            vm.page =  vm.isFromSeeMore ? vm.page : pagingParams.page;
            vm.queryCount = vm.totalItems;
            vm.transition(notify);
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            if (vm.isFromSeeMore) {
                var backToLastPage = JSON.parse(localStorage.getItem("warnings-page-back-detail"));
                vm.page = backToLastPage.pageBack;
                vm.itemsPerPageChosen = backToLastPage.sizeBack;
            }
            $state.transitionTo($state.$current, {
                sort: sort(),
                page: vm.page,
                filter: vm.filter,
                search: vm.searchParams,
                predicates: vm.predicates,
                itemsPerPageChosen: vm.itemsPerPageChosen
            }, {notify: notify, location: "replace"});
            if (vm.isFromSeeMore) {
                localStorage.setItem("is-from-see-more", JSON.stringify({isFromSeeMore: false}));
                vm.isFromSeeMore = false;
            }
        }

        vm.loadWarningsGroup = function () {
            for (var i = 0; i < Object.keys(vm.warnings.warningName).length; i++) {
                vm.warnings.warningName[i].expanded = false;
            }
        };

        vm.detail = function (warning) {
            if (!warning.expanded) {
                vm.loadWarningsGroup();
            }
            warning.expanded = !warning.expanded;
            vm.warningsGroup = [];
            if (warning.expanded) {
                var page = {
                    page: 0,
                    size: vm.itemsPerPageChosen,
                    sort: sort(),
                    search: vm.searchParams
                };

                vm.filterDetail = angular.copy(vm.filter);
                vm.filterDetail.warningFleet = warning.fleetName;
                vm.filterDetail.warningName = warning.name;
                vm.filterDetail.warningObjectCode = warning.objectUniqueCode;
                vm.filterDetail.warningGetAll = null
                WarningsDashboard.search(page, vm.filterDetail, onSuccessDetail, onErrorDetail);

                function onSuccessDetail(data) {
                    vm.warningsGroup = data[0].warningName[0];

                    if (warning.count > vm.seeMore) {
                        var name = {name: "See More"};
                        vm.warningsGroup.push(name);
                    }
                }

                function onErrorDetail() {
                }
            }
        };

        vm.openSeeMore = function (warning) {
            vm.savePage();
            localStorage.setItem("save-filter", JSON.stringify(vm.filter));
            localStorage.setItem("is-from-see-more", JSON.stringify({isFromSeeMore: true}));
            $state.transitionTo("warnings-list-detail", {
                page: 1,
                sort: sort(),
                predicates: vm.predicates,
                search: vm.searchParams,
                filter: vm.filter,
                itemsPerPageChosen: 10,
                name: warning.name,
                objectUniqueCode: warning.objectUniqueCode,
                fleet: warning.fleetName
            })
        };

        vm.saveIndex = function (index) {
            vm.indexColor = index;
            return vm.indexColor % 2 == 0;
        }

        function applySearch() {
            pagingParams.page = 1;
            resetTableToExport();
            vm.loadAll(false);
        }

        function parseWarningLevel(level) {
            return "warning-level " + (level === 1 ? "lv-low" : level === 2 ? "lv-medium" : "lv-high");
        }

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            vm.savePage();
           vm.transition();
        }

        vm.loadPage = function() {
            vm.savePage();
            localStorage.setItem("save-filter", JSON.stringify(vm.filter));
            pagingParams.page = vm.page;
            resetTableToExport();
            vm.loadAll(false);
        };

        function applySort(field) {
            if (!sortingMap[field]) {
                sortingMap[field] = "+";
                vm.sortIcon[field] = '-by-attributes';
            } else if (sortingMap[field] === '+') {
                sortingMap[field] = "-";
                vm.sortIcon[field] = "-by-attributes-alt";
            } else {
                delete sortingMap[field];
                delete vm.sortIcon[field];
            }
            vm.sorting = Object.keys(sortingMap).map(function (field) {
                return sortingMap[field] + field;
            });

        }

        function applyWarningFilter() {
            if (vm.filter.start < vm.filter.end || vm.filter.start == vm.filter.end) {
                collectFleets();
                collectCategories();
                collectWarnings();
                vm.filter.fleets = angular.copy(vm.selectedFleets);
                vm.filter.categories = angular.copy(vm.selectedCategories);
                vm.filter.warningNames = angular.copy(vm.selectedWarningNames);
                localStorage.setItem("save-filter", JSON.stringify(vm.filter));
                resetTableToExport();
                vm.loadAll(false);
            } else {
                AlertService.error("Error validation date.");
            }
        }

        function loadAllToExport() {
            var page = {
                page: 0,
                size: 2000,
                sort: sort(),
                search: vm.searchParams
            };
            var dataExport = {
                ch: vm.searchParams,
                filter: pagingParams.filter
            };

            function onSuccessExport(data, headers) {
                vm.totalItemsExport = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.tabObjectsToExport.push(data[i]);
                }
                if (vm.tabObjectsToExport.length < vm.totalItemsExport) {
                    page.page = page.page + 1;
                    WarningsDashboard.search(page, vm.filter, onSuccessExport, onErrorExport);
                } else {
                    vm.filter.warningGetAll = null;
                }
            }

            function onErrorExport(error) {
                AlertService.error(error.data.message);
                reject();
            }

            // Table to export is empty --> reload data from backend
            if (vm.tabObjectsToExport.length < 1) {
                vm.filter.warningGetAll = "all";
                WarningsDashboard.search(page, vm.filter, onSuccessExport, onErrorExport);
            }
        }

        function exportTable(type) {
            if (type == 'pdf') {
                $('#tableToExport').tableExport({
                    type: 'pdf',
                    pdfFontSize: '7',
                    escape: 'false',
                    size: {0: 50, 1: 105, 2: 90, 3: 90, 4: 100, 5: 35, 6: 50, 8: 92, 9: 105},
                    tableName: 'Warnings'
                });
            } else if (type != null) {
                $('#tableToExport').tableExport({type: type, escape: 'false', tableName: 'Warnings'});
            }
        }

        vm.showStatus = function (status) {
            if (status)
                return "Unprocess";
            else return "Process";
        }

        vm.wipStatus = function (warning) {
            $uibModal.open({
                templateUrl: 'app/dashboards/warnings-list/warning-list-wip-dialog.html',
                controller: 'SingleWipDialogController',
                backdrop: 'static',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('warning');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', function () {
                        return warning;
                    }]
                }
            });
        };

        vm.showDetail = function (warning) {
            TabObjects.byUniqueCode({uniqueCode: warning.objectUniqueCode}).$promise.then(function (object) {
                AlertRules.get({id: warning.warningId}).$promise.then(function (rule) {
                    var date = new Date(warning.date);
                    var range = 1800;
                    if (rule.frequency > range) {
                        range = rule.frequency;
                    }
                    var dateTo;
                    if (warning.status === "close") {
                        dateTo = new Date(warning.dateClose).getTime() + 600000;
                    } else {
                        dateTo = date.getTime() + ((+range + 1800) * 1000);
                    }
                    $state.transitionTo('tab-objects-dashboard-detail', {
                        id: object.id,
                        fleet: warning.fleetId,
                        objType: object.objectType.id,
                        warningName: warning.name,
                        warningDateFrom: date.setTime(date.getTime() - (range * 1000)),
                        warningDateTo: date.setTime(dateTo)
                    }, {notify: true, location: "replace"});
                });
            });
        };

        vm.categoryListSettings = {
            checkboxes: true,
            smartButtonMaxItems: 10,
            buttonDefaultText: "select categories",
            scrollable: true,
            enableSearch: true,
            clearSearchOnClose: true,
        };
        vm.warningListSettings = {
            checkboxes: true,
            smartButtonMaxItems: 10,
            buttonDefaultText: "select warnings",
            scrollable: true,
            enableSearch: true,
            clearSearchOnClose: true,
        };
        vm.fleetListSettings = {
            checkboxes: true,
            smartButtonMaxItems: 10,
            buttonDefaultText: "select fleet(s)",
            scrollable: true,
            enableSearch: true,
            clearSearchOnClose: true,
        };

        vm.fleetListEvent = {
            onSelectAll: function () {
            },
            onDeselectAll: function () {
            },
            onItemSelect: function () {
            },
            onItemDeselect: function () {
            },
        };
        vm.categoryListEvent = {
            onSelectAll: function () {
            },
            onDeselectAll: function () {
            },
            onItemSelect: function () {
            },
            onItemDeselect: function () {
            },
        };
        vm.warningListEvent = {
            onSelectAll: function () {
            },
            onDeselectAll: function () {
            },
            onItemSelect: function () {
            },
            onItemDeselect: function () {
            },
        };

        function collectFleets() {
            vm.selectedFleets = [];
            for (var x = 0; x < vm.tabFleets.length; x++) {
                for (var i = 0; i < vm.filter.fleets.length; i++) {
                    if (vm.tabFleets[x].id == vm.filter.fleets[i].id) {
                        vm.selectedFleets.push(vm.tabFleets[x]);
                    }
                }
            }
        }

        function collectCategories() {

            vm.selectedCategories = [];
            var systemExists = false;

            for (var i = 0; i < vm.filter.categories.length; i++) {
                if (vm.filter.categories[i].id === -1) {
                    systemExists = true;
                } else {
                    for (var j = 0; j < vm.categories.length; j++) {
                        if (vm.categories[j].id === vm.filter.categories[i].id) {
                            vm.selectedCategories.push(vm.categories[j]);
                            break;
                        }
                    }
                }
            }

            if (systemExists) {
                vm.selectedCategories.push({id: -1, warningName: "Monitoring Warning"})
            }

        }


        /**
         * vm.filter.warningNames:  array containing rules selected by the user                             { id:{}. warningName:{} } coming from Warning History, { id:{} } coming from My Domain Notification
         * vm.warningNameOptions:   array containing waring names selectable by the user in the UI model    { id:{}, label:{} }
         * vm.warningNames:         array containing rules read from database warning table                 { id: {}, warningName:{} }
         */
        function collectWarnings() {

            vm.selectedWarningNames = [];

            for (var i = 0; i < vm.filter.warningNames.length; i++) {
                for (var j = 0; j < vm.warningNameOptions.length; j++) {

                    // Need to filter by name/label (not only by id) because element must be selectable in UI (see how warningNameOptions is populated)
                    if (
                        vm.filter.warningNames[i].id === vm.warningNameOptions[j].id ||
                        vm.filter.warningNames[i].name === vm.warningNameOptions[j].label
                    ) {

                        // Need to select element from warningNames to query BE
                        for (var k = 0; k < vm.warningNames.length; k++) {

                            if(vm.warningNameOptions[j].id === vm.warningNames[k].id) {
                                vm.selectedWarningNames.push(vm.warningNames[k])
                            }
                        }
                    }
                }
            }
        }


        function resetTableToExport(){
            vm.tabObjectsToExport = [];
        }

        vm.precompile = function () {

            const noPageOrFirstPage = !$state.params.page || parseInt($state.params.page, 10) === 1;
            if (noPageOrFirstPage) {
                vm.restoreFilter();
            }

            vm.fleetSelectedAtStart = [];
            vm.categorySelectedAtStart = [];
            vm.warningSelectedAtStart = [];

            if (vm.myDomainNotification != null) {   // to fill filter in case this page is opened through mail link.
                vm.filter.fleets = [];
                vm.filter.categories = [];
                vm.filter.warningNames = [];
                vm.filter.fleets = angular.copy(vm.myDomainNotification.fleets);
                vm.filter.categories = angular.copy(vm.myDomainNotification.categories);
                vm.filter.warningNames = angular.copy(vm.myDomainNotification.warningNames);
                vm.filter.status = angular.copy(vm.myDomainNotification.status);
                vm.filter.objectsStatus = angular.copy(vm.myDomainNotification.objectsStatus);
                var executionTime = new Date(vm.myDomainNotification.nextExecutionDatetime);
                var end = new Date();
                var start = new Date();
                end.setHours(executionTime.getHours(), executionTime.getMinutes(), 0, 0);
                start.setHours(executionTime.getHours(), executionTime.getMinutes(), 0, 0);
                start.setDate(start.getDate() - vm.myDomainNotification.frequency);
                vm.filter.start = angular.copy(start);
                vm.filter.end = angular.copy(end);
                vm.myDomainNotification = null;

                vm.systemWarningExists = false;
                vm.filter.fleets.forEach(function (fleet) {   // getting all the fleets from entity and set it inside the dropdown list as (id, label).
                    vm.fleetSelectedAtStart.push({id: fleet.id, label: fleet.fleetName});
                });
                vm.filter.fleets = angular.copy(vm.fleetSelectedAtStart);

                vm.filter.categories.forEach(function (category) {   // getting all the categories from entity and set it inside the dropdown list as (id, label).
                    vm.categorySelectedAtStart.push({id: category.id, label: category.warningName});
                });
                vm.filter.categories = angular.copy(vm.categorySelectedAtStart);

                vm.filter.warningNames.forEach(function (warning) {   // getting all the warnings from entity and set it inside the dropdown list as (id, label).
                    if (warning.warningCategory == null || warning.warningCategory.id === -1) {
                        warning.warningCategory = {id: -1, warningName: "Monitoring Warning"}
                        vm.systemWarningExists = true;
                    }
                    warning.label = warning.name;
                    vm.warningSelectedAtStart.push(warning);
                });
                if (vm.systemWarningExists) {     // adding (system) to selected category in case systemWarning found
                    vm.filter.categories.push({id: -1, label: "Monitoring Warning"});
                }
                vm.filter.warningNames = angular.copy(vm.warningSelectedAtStart);
            } else {
                vm.systemWarningExists = false;
                vm.filter.fleets.forEach(function (fleet) {   // getting all the fleets from entity and set it inside the dropdown list as (id, label).
                    vm.fleetSelectedAtStart.push({id: fleet.id, label: fleet.fleetName});
                });
                vm.filter.fleets = angular.copy(vm.fleetSelectedAtStart);

                var categoryIds = [];
                vm.filter.categories.forEach(function (category) {   // getting all the categories from entity and set it inside the dropdown list as (id, label).
                    vm.categorySelectedAtStart.push({id: category.id, label: category.warningName});
                    categoryIds.push(category.id);
                });
                vm.filter.categories = angular.copy(vm.categorySelectedAtStart);

                vm.filter.warningNames.forEach(function (warning) {   // getting all the warnings from entity and set it inside the dropdown list as (id, label).
                    if (warning.warningCategory == null || warning.warningCategory.id === -1) {
                        warning.warningCategory = {id: -1, warningName: "Monitoring Warning"}
                        vm.systemWarningExists = true;
                    }
                    warning.label = warning.name;
                    vm.warningSelectedAtStart.push(warning);
                });
                if (vm.systemWarningExists && categoryIds.includes(-1)) {     // adding (system) to selected category in case systemWarning found
                    vm.filter.categories.push({id: -1, label: "Monitoring Warning"});
                }
                vm.filter.warningNames = angular.copy(vm.warningSelectedAtStart);
            }

        }

        vm.restoreFilter = function () {
         vm.filter = angular.copy(JSON.parse(localStorage.getItem('save-filter')));
         if (vm.filter.start !== undefined)
            vm.filter.start = angular.copy(new Date(vm.filter.start));
         if (vm.filter.end !== undefined)
             vm.filter.end = angular.copy(new Date(vm.filter.end));
        }

        vm.savePage = function () {
            var pageBackDetail = {
                pageBack: vm.page,
                sizeBack: vm.itemsPerPageChosen
            }
            localStorage.setItem("warnings-page-back-detail", JSON.stringify(pageBackDetail));
        }

        $q.all([
            fleetsPromise,
            categoriesPromise,
            systemWarningsPromise,
            warningsPromise
        ]).then(function () {

            vm.precompile();

            const noPageOrFirstPage =
                !$state.params.page || parseInt($state.params.page, 10) === 1;

            if (noPageOrFirstPage) {
                applyWarningFilter();
            }

        });
    }
})
();
